// Menu quality letter grade derived from the detection penalty score (higher
// score = worse). Single source of truth shared by the analyzer (Olympus
// `computeQualityScore`) and the dashboard (Hermes `detectionReportGrading`) so
// the grade a merchant sees never drifts between the two. The boundaries align
// with the detection-report tier cutoffs in `computeQualityScore`.
export const MENU_QUALITY_GRADE_THRESHOLDS = [
    { label: 'A', max: 0 },
    { label: 'B', max: 10 },
    { label: 'C', max: 18 },
    { label: 'D', max: 25 },
];
export const getMenuQualityLetterGrade = (qualityScore) => MENU_QUALITY_GRADE_THRESHOLDS.find(({ max }) => qualityScore <= max)?.label ??
    'F';
//# sourceMappingURL=quality.js.map